//----React imports
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
//---Project
import "./styles.css";
import { heartBeatStart } from "apis/eolApis";
import { formatHourAndMinsAndSecs } from "components/Common/Utils";
import {
  setHBStartDetails,
  setHBTestRunningStatus,
  setSelectedHBTestId,
} from "reducers/eolTestsSlice";
import { setNavStop } from "reducers/authSlice";

const StartHBTest = ({ stopTest, startTest }) => {
  const dispatch = useDispatch();
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const testDuration = vehicleDetails?.connectivityTestDuration;
  const imei = vehicleDetails?.vehImei;
  const HBStartDetails = eol?.HBStartDetails;
  const HBTestRunningStatus = eol?.HBTestRunningStatus;

  const startHeartBeatTest = useMutation({
    mutationFn: heartBeatStart,
    retry: 0, // By default retry is 3. Disable retries for post start-heart-beat-test
    onSuccess: (data) => {
      dispatch(setHBTestRunningStatus(true));
      dispatch(setNavStop(true));
      dispatch(setHBStartDetails(data));
      dispatch(setSelectedHBTestId(data?.testId));
      setTestState("testing");
    },
    onError: (error) => {
      dispatch(setHBTestRunningStatus(false));
      dispatch(setNavStop(false));
      dispatch(
        setSelectedHBTestId(vehicleDetails?.previousTests?.connectivity)
      );
      toast.error("Start Request Failed!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
        closeButton: false,
      });
      setTestState("failed");
      setTimeout(() => {
        setTestState("start");
      }, 3000);
      console.log("API Error--->", error.message);
    },
  });

  const [countDownTimer, setCountDownTimer] = useState(30);
  const [testTimeElapsed, setTestTimeElapsed] = useState(false);
  const [testState, setTestState] = useState("start");

  const onClickStart = () => {
    if (!HBTestRunningStatus) {
      startHeartBeatTest.mutate(imei);
    }
  };

  useEffect(() => {
    if (HBTestRunningStatus && testTimeElapsed) {
      setTestState("fetching");
    } else if (HBTestRunningStatus) {
      setTestState("testing");
    } else {
      setTestState("start");
    }
  }, [HBTestRunningStatus, testTimeElapsed]);

  useEffect(() => {
    if (HBTestRunningStatus) {
      let timeDiff = Math.round(
        (Date.now() - HBStartDetails?.startTime) / 1000
      );
      if (timeDiff < testDuration) {
        setCountDownTimer(
          timeDiff >= 0 ? testDuration - timeDiff : testDuration
        );
      } else {
        setCountDownTimer(0);
        setTestTimeElapsed(true);
      }

      if (countDownTimer <= 0 || testTimeElapsed) {
        console.log("call stop API here....");
        return;
      }
      const intervalId = setInterval(() => {
        setCountDownTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    } else {
      setCountDownTimer(testDuration);
      setTestTimeElapsed(false);
    }
    // eslint-disable-next-line
  }, [countDownTimer, HBTestRunningStatus, HBStartDetails?.startTime]);

  return (
    <>
      <span className="mr1 fs1">
        {formatHourAndMinsAndSecs(countDownTimer)}
      </span>
      {HBTestRunningStatus ? (
        <Link className={testState} disabled>
          {testState.charAt(0).toUpperCase() + testState.slice(1)}
        </Link>
      ) : (
        <Link className={testState} onClick={onClickStart}>
          {testState.charAt(0).toUpperCase() + testState.slice(1)}
        </Link>
      )}
    </>
  );
};

export default StartHBTest;
